module.exports = __webpack_public_path__ + "static/img/cont49 (4).45dcabe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (4).jpg
// module id = W/DU
// module chunks = 0